<div class="templates-panel">
  <!-- Header -->
  <div class="templates-header">
    <div class="templates-title-section">
      <h2 class="templates-title">Templates</h2>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="templates-loading">
    <div class="loading-spinner"></div>
    <p>Loading templates...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="templates-error">
    <div class="error-message">
      <h3>Oops! Something went wrong</h3>
      <p>{{ error }}</p>
    </div>
  </div>

  <!-- Templates List -->
  <div *ngIf="!loading && !error" class="templates-list">
    <div *ngIf="templates.length === 0" class="templates-empty">
      <p>No templates available</p>
    </div>
    <div *ngIf="templates.length > 0" class="templates-grid">
      <app-template-card
        *ngFor="let template of templates; trackBy: trackByTemplateId"
        [template]="template"
        [isLoading]="loading"
        (templateSelect)="onTemplateSelect($event)"
        (templatePreview)="onTemplatePreview($event)">
      </app-template-card>
    </div>
  </div>
</div>
